function watchEngraveInput() {
  const checkInterval = 1000; // 1秒ごとにチェック
  const maxAttempts = 30; // 最大30秒まで試行（無限ループ回避）
  let attempts = 0;

  let isSanitizing;
  let isComposing = false;
  let justFinishedComposing = false; // ← 追加
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const selectors = {
    form: 'form.product-form',
    engraveInput: '[type="text"][data-field-name="刻印"]',
    allowedString: '.engrave-option-allowed-chars .gpo-heading',
    maxLength: '.engrave-option-max-length',
    acceptTerms: '[type="checkbox"][name="accept-terms"]',
    addToCartButton: 'form.product-form .gpo-clone-atc-button',
    addToCartLabel: '.product-form [data-add-to-cart-text]',
  };

  // 絵文字→ASCII に置換
  const emojiMap = {
    '⭐': '☆',
    'ほし': '☆',
    'ホシ': '☆',
    '❤️': '♡',
    '🩷': '♡',
    '🧡': '♡',
    '💛': '♡',
    '💚': '♡',
    '🩵': '♡',
    '💙': '♡',
    '💜': '♡',
    '🖤': '♡',
    '🩶': '♡',
    '🤍': '♡',
    '♠️': '♤',
    'はーと': '♡',
    'ハート': '♡',
    '☘️': '♧',
    '🍀': '♧',
    '♦️': '♢',
    '🔸': '♢',
    '🔹': '♢',
    'ひしがた': '♢',
    '菱形': '♢',
    'だいあもんど': '♢',
    'ダイアモンド': '♢',
    '🔼': '△',
    '🔺': '△',
    '▲': '△',
    'さんかく': '△',
    '⭕': '◯',
    '⚪': '◯',
    '🔳': '□',
    '🔲': '□',
    '◾️': '□',
    '◽️': '□',
    '◼️': '□',
    '◻️': '□',
    '🟥': '□',
    '🟧': '□',
    '🟨': '□',
    '🟩': '□',
    '🟦': '□',
    '🟪': '□',
    '⬛️': '□',
    '⬜️': '□',
    '🟫': '□',
    'しかく': '□',
    '。': '.',
  };

  function toHalfWidth(str) {
    return str.replace(/[Ａ-Ｚａ-ｚ]/g, (ch) => {
      return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
    });
  }

  const intervalId = setInterval(() => {
    let input = document.querySelector(selectors.engraveInput);
    
    // 条件を満たしたら処理実行
    if (input) {
      
      clearInterval(intervalId); // チェック停止
      // console.log(`${attempts}回目の施行`);

      input = input ?? document.querySelector(selectors.engraveInput);
      let form = document.querySelector(selectors.form);
      const allowedText = document.querySelector(selectors.allowedString)?.textContent.trim() ?? "";
      const productOptionPro = document.querySelector('a[href*="product-options-pro"]');
      const engraveOptionMaxLength = document.querySelector(selectors.maxLength);
      const checkbox = document.querySelector(selectors.acceptTerms);

      let addCartButton = document.querySelector(selectors.addToCartButton);
      let addCartButtonLabel = document.querySelector(selectors.addToCartLabel);
      
      input.setAttribute('inputmode', 'latin');
      input.setAttribute('lang', 'en');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('spellcheck', 'false');
      // input.setAttribute('autocapitalize', 'characters'); // 大文字強制

      // let addCartButtonOriginalLabel;
      // let addCartButtonDisabledLabel = 'オプションを入力してください';

      if (productOptionPro) {
        const poweredBy = document.querySelector('a[href*="product-options-pro"]').closest('.gpo-form__group');

        if (poweredBy) {
          poweredBy.style.setProperty("display", "none");
        }
      }

      // console.log('%c GPO option found. Applying restrictions……', 'color: lime');

      // 最大文字数を制限 (アプリでは有料オプション)
      const maxLength = engraveOptionMaxLength ? parseInt(engraveOptionMaxLength.textContent.trim()) : '6';
      input.maxLength = maxLength;

      // 許可文字とスペースを取り除く正規表現
      const escapedAllowed = allowedText.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      const allowedRegex = new RegExp(`[^${escapedAllowed}]`, 'g');
      const spaceRegex = /\s|　/g; // 半角・全角スペース両方にマッチ

      // 許可された文字列に小文字・大文字があるか
      const hasUpper = /[A-Z]/.test(allowedText);
      const hasLower = /[a-z]/.test(allowedText);

      if (hasUpper && !hasLower) {
        input.setAttribute("autocapitalize", "on");
      }

      function normalizeCase(str) {
        // 大文字のみ許可 → 全て大文字に変換
        if (hasUpper && !hasLower) {
          return str.toUpperCase();
        }
        return str;
      }

      function getSanitized(input) {
        if (isSanitizing) return ''; // 再帰防止
        isSanitizing = true;

        if (!input) return '';

        let original = input.value;
        let sanitized = original;

        // 全角アルファベットを半角に変換
        sanitized = toHalfWidth(original);

        // allowedText に基づいて大小文字を変換
        sanitized = normalizeCase(sanitized);

        // 絵文字変換
        for (const [emoji, replacement] of Object.entries(emojiMap)) {
          sanitized = sanitized.split(emoji).join(replacement);
        }

        // 不正文字とスペースを削除
        sanitized = sanitized.replace(spaceRegex, '').replace(allowedRegex, '');

        // 文字数カット
        if (sanitized.length > maxLength) {
          sanitized = sanitized.slice(0, maxLength);
        }

        isSanitizing = false;

        return sanitized;
      }

      function shouldSkip(e) {
        return isComposing || justFinishedComposing || e.detail?.fromSanitize;
      }

      function sanitizeInput() {
        const cleandText = getSanitized(input);
        input.value = cleandText;
        console.log('[Sanitized Value]', cleandText);
        
        // 最後の1文字の変換が FormData に反映されないので確実にアップデートする
        const nativeInputSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        nativeInputSetter.call(input, cleandText);

        // テキスト変換が完全に終わったあとにあらためてイベントを発火してフォームに伝える
        // 無限ループを防ぐためカスタムフラグを追加
        input.dispatchEvent(new CustomEvent('input', { bubbles: true, detail: { fromSanitize: true } }));
        input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { fromSanitize: true } }));

        // 入力条件を満たしていない場合カートボタンを押せないようにする
        if (addCartButton) {
          if (cleandText.length === 0) {
            // console.log('%c No letters. Cart button disabled', 'color: red');
            addCartButton.disabled = true;
            addCartButton.style.setProperty('pointer-events', 'none');
            addCartButton.style.setProperty('opacity', '50%');
          } else {
            // console.log('%c Has letters. Cart button enabled', 'color: lime');
            addCartButton.disabled = false;
            addCartButton.style.removeProperty('pointer-events');
            addCartButton.style.removeProperty('opacity');
          }
        }
      }

      // スマートフォンIME対策
      if (isMobile) {
        console.log('is mobile');

        input.addEventListener('input', (e) => {
          if (shouldSkip(e)) return;
          sanitizeInput();
          // checkFormData();
        });

        input.addEventListener('compositionstart', () => { isComposing = true });
        input.addEventListener('compositionend', (e) => {
          isComposing = false;
          justFinishedComposing = true;
          sanitizeInput();
          // 次のinputイベントをスキップするため、すぐにリセットはしない
          setTimeout(() => {
            justFinishedComposing = false;
            sanitizeInput(); // ← IMEが再セットした後にもう一度かける
          }, 100);

          checkFormData();
        });
      } else {

        // ! IME入力中も発火するため相性が誤作動しやすい
        // input.addEventListener('keyup', (e) => {
        //   if (shouldSkip(e)) return;
        //   sanitizeInput();
        // });
        
        // 手動貼り付けなどの対応で必要
        input.addEventListener('change', (e)=>{
          if (shouldSkip(e)) return;
          sanitizeInput();
        }); 

        // 入力終了後
        input.addEventListener('blur', (e) => {
          if (shouldSkip(e)) return;
          sanitizeInput();
        });
      }
    
      sanitizeInput(); // 初期状態でもチェック

      function checkFormData() {
        if (form) {
          const formData = new FormData(form);
          const dataObject = Object.fromEntries(formData.entries());
          const jsonString = JSON.stringify(dataObject);
          console.log('[Actual Value] :', dataObject['properties[刻印]']);
          // console.log(jsonString);
        }
      }

      // iOS で確定 を押すとカートボタンに入ってしまう
      document.querySelectorAll('.product-form input[type="text"]').forEach(input => {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && !isComposing ) {
            e.preventDefault(); // フォーム送信を防ぐ
            this.blur();        // フォーカスを外す（キーボードが閉じる）
          }
        });
      });

    }

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(intervalId); // 最大試行回数を超えたらやめる
    }
  }, checkInterval);
}

document.addEventListener('DOMContentLoaded', function () {
  watchEngraveInput();
});